<!-- src/pages/customers/create.vue -->
<template>
  <form @submit.prevent="handleSubmit">
    <section class="page-header mb-3">
      <div class="container d-flex justify-content-between align-items-end">
        <div class="page-header-title">
          <h1 class="h3 mb-1">
            <i class="fa-solid fa-layer-group"></i>
            {{ $t('page.customers.create_title') }}
          </h1>
          <p class="text-light opacity-75 mb-0">{{ $t('page.customers.create_description') }}</p>
        </div>
        <div class="page-header-actions">
          <button class="btn btn-sm btn-primary me-2" id="home" @click.prevent="handleIndex()"
            :title="$t('common.home')">
            <i class="fa fa-home"></i> {{ $t('common.home') }}
          </button>
          <button class="btn btn-sm btn-success" id="save" type="submit" :title="$t('common.save')">
            <i class="fa fa-save"></i>
          </button>
        </div>
      </div>
    </section>

    <section class="container">
      <div class="card">
        <div class="card-body">
          <Form v-model:form="form" :errors="errors" />
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="btn btn-sm btn-success" type="submit"><i class="fa fa-save"></i> {{ $t('common.create') }}</button>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from 'vue-router';
import { useCustomerStore } from '@/stores/customerStore';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue3-toastify';
import Form from './_form';

const router = useRouter();
const customerStore = useCustomerStore();
const { t } = useI18n();
const form = ref({});
const errors = ref({});

// Submit
const handleSubmit = async () => {
  try {
    await customerStore.createCustomer(form.value);
    await toast.success(t('common.created'), { autoClose: 3000 });
    router.push({ name: 'customers-index' });
  } catch (error) {
    if (error.response.data.errors) {
      errors.value = error.response.data.errors;
    }
    toast.error(t('common.createError'));
  }
};

// Go to Index
const handleIndex = () => {
  router.push({ name: "customers-index" });
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #2c3e50, #4a6580);
  color: white;
  padding: 20px 0;
}
</style>